import React from 'react';
import { number } from '../../../Common/Util/number';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

export const TableEvolutionTeam = () => {
    const { chartData } = useMappingChartsDataContext();

    const columns = [
        {
            key: 'description',
            header: 'Equipe',
            headerStyle: {
                width: '60%',
                fontWeight: '500'
            },
            cellStyle: {}
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: {
                width: '40%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    const calculateTotals = (data) => {
        if (!data || !Array.isArray(data)) return null;

        return {
            description: 'Total',
            total: data.reduce((acc, curr) => acc + Number(curr.total || 0), 0)
        };
    };

    const tableData = React.useMemo(() => {
        if (!chartData?.evolutionTeam) return [];

        const data = [...chartData.evolutionTeam];
        const totals = calculateTotals(chartData.evolutionTeam);

        if (totals) {
            data.push(totals);
        }

        return data;
    }, [chartData?.evolutionTeam]);

    return (
        <div className="chart-container-dashboards">
            <TableComponent
                data={tableData}
                columns={columns}
                title="Totais"
                showTotal={false}
                maxHeight="400px"
                className="w-100"
                isLastTotal
            />
        </div>
    );
};
